import { styled } from '@notino/react-styleguide';

export const Link = styled.a`
  color: inherit;
`;

export const ConditionsRow = styled.div`
  display: flex;
  flex-flow: row;
  gap: 0.3rem;

  align-items: center;
`;
